import { SidingType, SidingColor, SidingArea, hexCodeFor } from "./colors";


export class ColorizerState {
    constructor(public Trim: ConfiguredArea, public AreaA: ConfiguredArea, public AreaB: ConfiguredArea, public AreaC: ConfiguredArea ) { }

   static configForArea(state: ColorizerState, area: SidingArea) {
        switch (area) {
            case SidingArea.A: return state.AreaA;
            case SidingArea.B: return state.AreaB;
            case SidingArea.C: return state.AreaC;
            default: return state.Trim;
        }
    }

    static setConfigForArea(state: ColorizerState, area: SidingArea, config: ConfiguredArea) {
        switch (area) {
            case SidingArea.A: state.AreaA = config; break;
            case SidingArea.B: state.AreaB = config; break;
            case SidingArea.C: state.AreaC = config; break;
            default: state.Trim = config; break;
        }
    }

    static codeFor (state: ColorizerState) {
        return [
            state.Trim.SelectedColor.toString(),
            state.AreaA.SelectedColor.toString(),
            state.AreaA.SidingType.toString(),
            state.AreaB.SelectedColor.toString(),
            state.AreaB.SidingType.toString(),
            state.AreaC.SelectedColor.toString(),
            state.AreaC.SidingType.toString()
        ].join('.');
    }
}

export class ConfiguredArea {
    SelectedColor: SidingColor;
    SidingType: SidingType;

    constructor(color?: SidingColor, type?: SidingType) {
        this.SelectedColor = typeof color === 'number' ? color : -1;
        this.SidingType = type || SidingType.SelectSiding;
    }

    cssStyle() {
        return {
            'boxShadow' : "inset 0 0 0 1000px " + hexCodeFor(this.SelectedColor),
            'backgroundColor': "transparent"
        }
    }
}
